export default "__VITE_ASSET__3e25797b__"